import {ShiftEventCategory} from '@hconnect/common/types'
import {RemoveFilterButton} from '@widgets/common-filters'
import React from 'react'

import {FilterDropDown} from './FilterDropDown'
import type {CommonFilterDropDownProps} from './FilterDropDown'
import {SelectAllButton} from './SelectAllButton'

export const CategoryFilterDropDown: React.FC<CommonFilterDropDownProps<ShiftEventCategory>> = (
  props
) => {
  const {selectAll} = props
  return (
    <FilterDropDown
      {...props}
      options={Object.values(ShiftEventCategory)}
      keyName="category"
      fullWidth={false}
      customDropDownFooter={(keyName) =>
        props.isCollapsible ? null : (
          <>
            <SelectAllButton
              keyName={keyName}
              selectAll={() => selectAll && selectAll(keyName, Object.values(ShiftEventCategory))}
            />
            <RemoveFilterButton keyName={keyName} removeFilter={props.removeFilter} />
          </>
        )
      }
    />
  )
}
